import { makeSvgImage } from '../../../../components/SvgImage/index.ts';

export const Cloud2 = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" width="103" height="34" fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M93.34 31.268H6.88a13.586 13.586 0 0 1-.443-3.449c0-7.491 6.073-13.565 13.565-13.565.784 0 1.552.067 2.3.195C25.182 6.043 33.152 0 42.534 0c10.998 0 20.057 8.304 21.249 18.983a8.484 8.484 0 0 1 3.12-.59 8.505 8.505 0 0 1 7.465 4.423 8.517 8.517 0 0 1 2.192-.285 8.495 8.495 0 0 1 6.888 3.514 6.208 6.208 0 0 1 9.892 5.223Z"
      clipRule="evenodd"
    />
    <rect width="103" height="1.839" fill="#fff" rx=".92" transform="matrix(-1 0 0 1 103 31.268)" />
  </svg>,
);
